import React from 'react';
import { Users, Globe } from 'lucide-react';

const TwoModesSection: React.FC = () => {
  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-stone-900">
            Da igual la distancia. Lo que importa es la conversación.
          </h2>
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 md:gap-8">
          {/* Card: Juntos */}
          <div className="p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mb-4 border border-stone-100 text-rose-500">
              <Users size={28} />
            </div>
            <h3 className="text-xl font-semibold text-stone-900 mb-4">Juntos, en persona</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                Elegís un tema y le dais a grabar.
              </li>
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                La conversación fluye — Ethernal os guía con preguntas que sacan historias que no esperabais.
              </li>
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                Escucháis juntos lo que ha salido y añadís fotos si queréis.
              </li>
            </ul>
          </div>

          {/* Card: A distancia */}
          <div className="p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mb-4 border border-stone-100 text-rose-500">
              <Globe size={28} />
            </div>
            <h3 className="text-xl font-semibold text-stone-900 mb-4">A distancia, sin complicaciones</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                Le envías una invitación y graba cuando quiera, desde su móvil.
              </li>
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                Las mismas preguntas le guían paso a paso — como si estuvierais juntos.
              </li>
              <li className="flex items-start gap-3 text-stone-600 text-sm leading-relaxed">
                <span className="text-rose-400 shrink-0 mt-0.5">•</span>
                Todo llega a vuestra cápsula compartida. Para siempre.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoModesSection;
